// import react, { useEffect, useState } from "react";
// import './AdministracionSemaforo.scss';
// import Input from "../../../components/Atomsv2/Input/Input";
// import { semaforo, semaforoIncidentes, semaforoZonas } from "./AdministracionSemaforoIntegracion";
// import CardsHeader from "./partes/CardsHeader/CardsHeader";
// import GaficaYBarrasDeZona from "./partes/GaficaYBarrasDeZona/GaficaYBarrasDeZona";
// import TablaSemaforo from "./partes/TablaSemaforo/TablaSemaforo";
// import useGetDataUser from "../../../utilidades/customHooks/useGetDataUser";
// import GraficasIncidencias from "./partes/GraficasIncidencias/GraficasIncidencias";




// // Normaliza los campos del nuevo query según la categoría elegida
// const mapearData = (rawData, cat) => {
//     if (!Array.isArray(rawData)) return null;
//     return rawData.map(d => ({
//         ...d,
//         SERVICIOS: cat === 'SUMA'    ? d.SERVICIOS_SUMA
//                  : cat === 'ALIADOS' ? d.SERVICIOS_ALIADOS
//                  : d.SERVICIOS_TOTAL,
//         INCIDENTES: cat === 'SUMA'    ? d.INCIDENTES_SUMA
//                   : cat === 'ALIADOS' ? d.INCIDENTES_ALIADOS
//                   : d.INCIDENTES_TOTAL,
//         EFICIENCIA: cat === 'SUMA'    ? d.EFICIENCIA_SUMA
//                   : cat === 'ALIADOS' ? d.EFICIENCIA_ALIADOS
//                   : d.EFICIENCIA_TOTAL,
//     }));
// };

// const AdministracionSemaforo = () => {
//     const userData = useGetDataUser()
//     const [data, setData] = useState(null)
//     const [dataIncidente, setDataIncidente] = useState(null)
//     const [loading, setLoading] = useState(false)
//     const [filtroZona, setFiltroZona] = useState(null)
//     const [dataFiltrada, setDataFiltrada] = useState([])
//     const [zonasOperativas, setZonasOperativas] = useState([])
//     const [categoria, setCategoria] = useState('TODOS')
//     const [dataMapeada, setDataMapeada] = useState(null)

//     // Recalcula dataMapeada cuando llega data nueva o cambia la categoría
//     useEffect(() => {
//         if (data) setDataMapeada(mapearData(data, categoria));
//     }, [data, categoria])

//     // Filtra por zona usando dataMapeada (ya normalizada)
//     useEffect(() => {
//         if (filtroZona && dataMapeada) {
//             setDataFiltrada(dataMapeada.filter(d => d.ZONA === filtroZona));
//         } else if (!filtroZona) {
//             setDataFiltrada([]);
//         }
//     }, [filtroZona, dataMapeada])
//     useEffect(() => {
//         getData()
//     }, [])
//     // quitar el primer y ultimo catacter de userData?.ID_EMPRESA 
//     const getData = async () => {
//         setLoading(true)
//         // fecha_inicio y fehca fin denven ser las ultimas 3 semanas anteriores a la de hoy 
//         const rango = obtenerRangoAnioActual()
//         const params = {
//             fecha_inicio: rango.fechaInicio,
//             fecha_fin: rango.fechaFin,
//         }
//         await semaforo(params)
//             .then((value) => {
//                 setData(value)
//                 setLoading(false)
//             })
//             .catch((error) => {
//                 console.error(error);
//                 setLoading(false)
//             })
//         await semaforoIncidentes(params)
//             .then((value) => {
//                 setDataIncidente(value)
//                 setLoading(false)
//             })
//             .catch((error) => {
//                 console.error(error);
//                 setLoading(false)
//             })
//         await semaforoZonas()
//             .then((value) => {
//                 setZonasOperativas(value)

//             })
//             .catch((error) => {
//                 console.error(error);
//             })

//     }

//     function obtenerRangoAnioActual(fecha = new Date()) {
//         const anio = fecha.getFullYear();

//         const primerDia = `${anio}-01-01`;

//         // Calcular el domingo de la semana anterior
//         const lunes = new Date(fecha);
//         const diaActual = lunes.getDay();
//         if (diaActual === 0) {
//             lunes.setDate(lunes.getDate() - 6);
//         } else {
//             lunes.setDate(lunes.getDate() - (diaActual - 1));
//         }
//         const domingoAnterior = new Date(lunes);
//         domingoAnterior.setDate(domingoAnterior.getDate() - 1);

//         const fechaFin = [
//             domingoAnterior.getFullYear(),
//             String(domingoAnterior.getMonth() + 1).padStart(2, '0'),
//             String(domingoAnterior.getDate()).padStart(2, '0')
//         ].join('-');

//         return {
//             fechaInicio: primerDia,
//             fechaFin: fechaFin
//         };
//     }
//     return (
//         <div className="AdministracionSemaforo">
//             <CardsHeader loading={loading} data={dataMapeada} />
//             <GaficaYBarrasDeZona
//                 zonasOperativas={zonasOperativas}
//                 setFiltroZona={setFiltroZona}
//                 filtroZona={filtroZona}
//                 loading={loading}
//                 data={dataMapeada}
//                 dataFiltrada={dataFiltrada}
//                 categoria={categoria}
//                 setCategoria={setCategoria}
//             />
//             <TablaSemaforo loading={loading} data={filtroZona ? dataFiltrada : dataMapeada} />
//             <GraficasIncidencias loading={loading} data={dataIncidente} filtroZona={filtroZona} categoria={categoria} />
//         </div>
//     )
// }
// export default AdministracionSemaforo



import react, { useEffect, useState } from 'react'
import './AdministracionSemaforo.scss'
import Card from '../../../components/Atomsv2/Card/Card'
import Select from '../../../components/Atomsv2/Select/Select'
import { obtenerRangoAnioActual, semaforo, semaforoIncidentes, semaforoZonas, traerSemana, traerRangoPorSemana } from './AdministracionSemaforoIntegracion'
import Button from '../../../components/Atomsv2/Button/Button'
import CardDashboardV2 from './partes/CardsHeader/CardDashboardV2'
import GraficaYBarrasDeZonav2 from './partes/GaficaYBarrasDeZona/GraficaYBarrasDeZonav2'
import GraficasIncidencias from './partes/GraficasIncidencias/GraficasIncidencias'
import Table from '../../../components/moleculesv2/Table/Table'
import Column from '../../../components/moleculesv2/Table/Column'
import { getClientes } from '../../talentoHumano/OperadoresVetados/integracion'
const AdministracionSemaforo = () => {
    const metricas = [
        { name: "EFICIENCIA", value: "eficiencia" },
        { name: "INCIDENCIA", value: "incidencia" },
        { name: "SERVICIO", value: "servicio" },
        { name: "FACTURACION", value: "facturacion" },

    ]
    const periodos = [
        { name: "ULTIMAS 4 SEMANAS", value: "4semanas" },
        { name: "SEMANA SELECCIONADA", value: "hoy" },
        { name: "TODO", value: "todo" },
    ]
    const categorias = [
        { name: "SUMA", value: "suma" },
        { name: "ALIADOS", value: "aliados" },
        { name: "TODO", value: "todo" },
    ]
    const semanaActualN = traerSemana().semana;
    const semanas = Array.from({ length: semanaActualN }, (_, i) => ({ name: `Semana ${i + 1}`, value: i + 1 }));
    const [zonas, setZonas] = useState([])
    const [filtros, setFiltros] = useState({
        metrica: { name: "EFICIENCIA", value: "eficiencia" },
        periodo: { name: "ULTIMAS 4 SEMANAS", value: "4semanas" },
        categoria: { name: "TODO", value: "todo" },
        zona: null,
        cliente: null,
        semanaCustom: null
    })
    const [data, setData] = useState(null)
    const [dataIncidente, setDataIncidente] = useState(null)
    const [loading, setLoading] = useState(false)
    const [dataFiltrada, setDataFiltrada] = useState(null)
    const [dataIncidentesFiltrada, setDataIncidentesFiltrada] = useState(null)
    const [clientes, setClientes] = useState(null)

    useEffect(() => {
        if (semanaActualN) {
            
            setFiltros(prev => ({
                ...prev,
                semanaCustom: semanaActualN
            }))
        }
    }, [])
    useEffect(() => {
        if (data?.length > 0) {


            //  base.filter(d => d.SEMANA >= semanaActual - 3 && d.SEMANA <= semanaActual)
            let dataFiltrada = data
            let dataIncidentesFiltrada = dataIncidente

            const semanaActual = traerSemana().semana;

            // filtro de periodo / semana personalizada
            // semanaCustom tiene prioridad: sustituye la semana actual como destino del rango,
            // pero el periodo sigue determinando cuántas semanas atrás se incluyen.
            const semanaBase = filtros.semanaCustom ?? semanaActual;
            if (filtros.periodo.value === '4semanas') {
                const rango = traerRangoPorSemana(semanaBase, 3);
                dataFiltrada = data.filter(d => d.SEMANA >= rango.semanaInicio && d.SEMANA <= rango.semanaFin);
            } else if (filtros.periodo.value === 'hoy') {
                const rango = traerRangoPorSemana(semanaBase, 0);
                dataFiltrada = data.filter(d => d.SEMANA >= rango.semanaInicio && d.SEMANA <= rango.semanaFin);
            } else {
                dataFiltrada = data;
            }

            // Incidencias: usa la misma lógica que el semáforo general (semanaBase + periodo).
            const semanaBaseInc = filtros.semanaCustom ?? semanaActual;
            const rangoInc = filtros.periodo.value === '4semanas'
                ? traerRangoPorSemana(semanaBaseInc, 3)
                : filtros.periodo.value === 'hoy'
                    ? traerRangoPorSemana(semanaBaseInc, 0)
                    : null;
            dataIncidentesFiltrada = rangoInc
                ? (dataIncidente ?? []).filter(d => d.SEMANA >= rangoInc.semanaInicio && d.SEMANA <= rangoInc.semanaFin)
                : (dataIncidente ?? []);

            // filtro de zona
            if (filtros.zona) {
                dataFiltrada = dataFiltrada.filter(d => d.ZONA_OPERATIVA === filtros.zona.NOMBRE)
            }
            if (filtros.cliente) {
                dataFiltrada = dataFiltrada.filter(d => d.ID_CLIENTE === filtros.cliente.code)
                dataIncidentesFiltrada = dataIncidentesFiltrada.filter(d => d.ID_CLIENTE === filtros.cliente.code)
            }
            setDataIncidentesFiltrada(dataIncidentesFiltrada)
            setDataFiltrada(dataFiltrada ?? data)


        }

    }, [filtros, data, dataIncidente])
    useEffect(() => {
        getData()
    }, [])
    const getData = async () => {
        setLoading(true)
        await semaforoZonas().then((res) => {
            setZonas(res)
        })
            .catch((error) => {
                console.error(error);
            })
        const rango = obtenerRangoAnioActual()
        const params = {
            fecha_inicio: rango.fechaInicio,
            fecha_fin: rango.fechaFin,
        }
        await semaforo(params).then((res) => {
            setLoading(false)
            setData(res)
        })
            .catch((error) => {
                console.error(error);
            })
        await semaforoIncidentes(params).then((res) => {
            setLoading(false)
            setDataIncidente(res)
        })
            .catch((error) => {
                console.error(error);
            })
        await getClientes(setClientes)


    }
    return (
        <div className='AdministracionSemaforo'>
            <Card className={"filtrosSemaforo"}>
                <Select value={filtros.metrica}
                    mapper={{ name: "name", value: "value" }}
                    onChange={(value) =>
                        setFiltros(prev => ({
                            ...prev,
                            metrica: value
                        }))
                    }
                    cleaner={false}
                    label="MÉTRICA" options={metricas}></Select>
                <Select
                    value={filtros.semanaCustom !== null ? semanas[filtros.semanaCustom - 1] : null}
                    onChange={(value) =>
                        setFiltros(prev => ({
                            ...prev,
                            semanaCustom: value ? value.value : null
                        }))
                    }
                    label="SEMANA"
                    options={semanas}
                    mapper={{ name: "name", value: "value" }}
                ></Select>

                <Select
                    value={filtros.periodo}
                    mapper={{ name: "name", value: "value" }}
                    onChange={(value) =>
                        setFiltros(prev => ({
                            ...prev,
                            periodo: value
                        }))
                    }
                    cleaner={false}
                    label="PERIODO" options={periodos}></Select>
                <Select
                    value={filtros.categoria}
                    mapper={{ name: "name", value: "value" }}
                    onChange={(value) =>
                        setFiltros(prev => ({
                            ...prev,
                            categoria: value
                        }))

                    } label="PROVEEDOR" options={categorias}
                    cleaner={false}
                ></Select>
                <Select
                    value={filtros.zona}
                    onChange={(value) =>
                        setFiltros(prev => ({
                            ...prev,
                            zona: value
                        }))
                    } label="ZONA" options={zonas} mapper={{ name: "NOMBRE", value: "ID" }}
                    cleaner={true}
                ></Select>
                <Select
                    value={filtros.cliente}
                    onChange={(value) =>
                        setFiltros(prev => ({
                            ...prev,
                            cliente: value
                        }))
                    } label="CLIENTES" options={clientes ?? []} mapper={{ name: "name", value: "code" }}
                    cleaner={true}
                ></Select>
                {/* <Button>BUSCAR</Button> */}
            </Card>
            <Card>
                <CardDashboardV2 loading={loading} data={dataFiltrada}></CardDashboardV2>
                <GraficaYBarrasDeZonav2 fullData={data} loading={loading} data={dataFiltrada} filtros={filtros} zonasOperativas={zonas} />
            </Card>
            <GraficasIncidencias
                loading={loading}
                data={dataIncidentesFiltrada}
                filtroZona={filtros.zona?.NOMBRE ?? null}
                categoria={filtros.categoria.value.toUpperCase()}
                periodo={filtros.periodo.value}
                semanaCustom={filtros.semanaCustom}
            />
        </div>
    )
}
export default AdministracionSemaforo